<!--
 * @Author: hhy
 * @Description:  
-->
<template>
  <scroll-layout>
    <template #header>
      <div v-if="pageTopButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageTopButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
      <section class="el-row--flex card-info-area">
        <div class="card-info account-card-info">
          <div class="common-icon">
            <div class="big-icon account-icon"></div>
          </div>
          <div class="common-text">
            <div class="account-name">{{ accountInfo.userAccount || '—' }}</div>
            <div class="user-name">
              <span class="common-label-key">用户姓名：</span>
              <span class="common-label-val">{{ accountInfo.nickName || '—' }}</span>
            </div>
            <div class="user-name">
              <span class="common-label-key">手机号：</span>
              <span class="common-label-val">{{ accountInfo.userPhone || '—' }}</span>
            </div>
          </div>
        </div>
        <div class="white-stone"></div>
        <div class="card-info purse-card-info">
          <div class="common-icon">
            <div class="big-icon"></div>
          </div>
          <div class="common-text">
            <div class="purse-text">个人钱包</div>
            <div class="purse-balance">
              <span>{{ accountInfo.balance || '—' }}</span>
              <span class="purse-unit">元</span>
            </div>
          </div>
        </div>
      </section>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <ykc-table
      ref="YkcTable"
      title="资金流水"
      operateFixedType="right"
      :data="tableData"
      :columns="tableColumns"
      :operateButtons="tableOperateButtons">
      <template #headerButtons>
        <ykc-button
          v-for="(button, index) in pageButtons.filter(item => item.enabled())"
          :key="button.id || index"
          v-bind="button"
          @click="handlePageButtonClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </template>
      <ykc-pagination
        slot="pagination"
        ref="YkcPagination"
        direct="flex-end"
        :total="pageInfo.total"
        :page-size.sync="pageInfo.pageSize"
        :current-page.sync="pageInfo.pageIndex"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"></ykc-pagination>
    </ykc-table>

    <ykc-operation-dialog
      title="退款确认"
      size="large"
      :before-confirm="refundConfirm"
      confirm-btn-txt="确认退款"
      :show.sync="refundShow">
      <div slot="content">
        <div class="refund-container">
          <div class="tip">
            请注意：点击【确认退款】，本活动下全部优惠券和活动充值余额将全部清空，且不可恢复。请确认后操作。
          </div>
          <div class="amount">
            <div class="item-a item-a-red">
              <div class="top">可退金额</div>
              <div class="bottom">{{ refundInfo.refundableAmt }}元</div>
            </div>
            <div class="item-a">
              <div class="top">充值金额</div>
              <div class="bottom">{{ refundInfo.rechargeAmt }}元</div>
            </div>
            <div class="item-a">
              <div class="top">消费金额</div>
              <div class="bottom">{{ refundInfo.consumeAmt }}元</div>
            </div>
            <div class="item-a">
              <div class="top">已退款金额</div>
              <div class="bottom">{{ refundInfo.refundAmt }}元</div>
            </div>
            <div class="item-a">
              <div class="top">已优惠金额</div>
              <div class="bottom">{{ refundInfo.discountAmt }}元</div>
            </div>
          </div>
          <div class="tip-coupon">确认退款以下优惠券将作废</div>
          <ykc-table
            ref="YkcTableCoupon"
            :data="refundInfo.carCouponInfoList || []"
            :columns="tableCouponColumns"
            :operateButtons="[]"></ykc-table>
        </div>
      </div>
    </ykc-operation-dialog>
  </scroll-layout>
</template>

<script>
  import YkcOperationDialog from '@/components/ykc-ui/operation-dialog';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { cSideDriverAccount } from '@/service/apis';
  import { getLastTime, offlineExport } from '@/utils';

  export default {
    name: 'CSideDriverAccountsDetail',
    components: { YkcOperationDialog },
    data() {
      return {
        id: '',
        isEdit: false,
        dictionary: [
          { id: '1', name: '普通充值' },
          { id: '2', name: '微信活动充值' },
        ],
        accountInfo: {}, // 账户头部信息
        refundInfo: {}, // 退款信息
        refundId: '', // 退款id
        refundShow: false,

        pageTopButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        pageButtons: [],
        tableData: [],
        tableOperateButtons: [
          {
            render: (h, data, { row }) =>
              row.buttType === '1' ? (
                <ykc-button
                  type="text"
                  disabled={!row.buttEnable}
                  onClick={() => {
                    // 先清空数据
                    this.refundInfo = {};
                    this.refundId = row.id;
                    this.getRechargeRefundBox();
                    this.refundShow = true;
                  }}>
                  退款
                </ykc-button>
              ) : null,
          },
          {
            render: (h, data, { row }) =>
              row.buttType === '2' ? (
                <ykc-button
                  type="text"
                  disabled={!row.buttEnable}
                  onClick={() => {
                    // 先清空数据
                    this.refundInfo = {};
                    this.refundId = row.id;
                    this.getRechargeRefundBox();
                    this.refundShow = true;
                  }}>
                  超期退款
                </ykc-button>
              ) : null,
          },
        ],
        tableCouponColumns: [
          { label: '编号', prop: 'cardCouponId', minWidth: '150px' },
          { label: '名称', prop: 'cardCouponName', minWidth: '100px' },
          { label: '面额', prop: 'faceValue', minWidth: '50px' },
          { label: '数量', prop: 'num', minWidth: '50px' },
        ],
        tableColumns: [
          { label: '流水号', prop: 'flowNumber', width: '240px', fixed: true },
          { label: '流水类型', prop: 'flowTypeStr', minWidth: '120px' },
          { label: '流水对象', prop: 'flowObject', minWidth: '100px' },
          { label: '商户名称', prop: 'mchCodeName', minWidth: '120px' },
          { label: '微信回执单号', prop: 'rechargeRespNo', minWidth: '250px' },
          { label: '流水时间', prop: 'flowDate', width: '200px' },
          { label: '流水金额', prop: 'flowAmount', minWidth: '100px' },
          { label: '可退款金额', prop: 'refundableAmt', minWidth: '100px' },
          { label: '已退金额', prop: 'refundAmt', minWidth: '100px' },
          {
            label: '退款状态',
            prop: 'refundStatus',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                let statusStr = '——';
                if (row.refundStatus === 0) {
                  statusStr = '未退款';
                } else if (row.refundStatus === 1) {
                  statusStr = '已退款';
                } else if (row.refundStatus === 2) {
                  statusStr = '退款中';
                }

                return <span>{statusStr}</span>;
              },
            },
          },
          { label: '退款操作人', prop: 'createdName', minWidth: '100px' },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          flowNumber: '',
          flowType: '',
          flowObject: '',
          flowTime: [],
          flowTimeStart: '',
          flowTimeEnd: '',
          userId: '',
        },
      };
    },
    computed: {
      searchData() {
        return [
          {
            key: 'flowTime',
            label: '流水时间',
            comName: 'YkcDatePicker',
          },
          {
            comName: 'YkcInput',
            key: 'flowNumber',
            label: '流水号',
            placeholder: '请输入流水号',
          },
          {
            comName: 'YkcDropdown',
            key: 'flowType',
            label: '流水类型',
            placeholder: '请选择',
            data: this.dictionary,
          },
        ];
      },
    },
    created() {
      const { id } = this.$route.query;
      this.id = id;
      this.searchParams.userId = id;

      // 近30天初始化时间
      const startDate = getLastTime('yyyy-MM-dd', 30);
      const endDate = getLastTime('yyyy-MM-dd', 0);

      this.searchParams.flowTime = [startDate, endDate];
      this.searchParams.flowTimeStart = startDate;
      this.searchParams.flowTimeEnd = endDate;

      this.queryHeaderInfo();
      this.searchTableList();
    },
    methods: {
      /**
       * 退款
       */
      refundConfirm() {
        cSideDriverAccount.rechargeRefund({ id: this.refundId }).then(res => {
          this.$message.success('保存成功');
          this.searchTableList();
          this.queryHeaderInfo();
          this.refundShow = false;
          this.refundId = '';
        });
      },
      changeStateSearch() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      /**
       * @function queryHeaderInfo
       * @desc 查询头部新消息
       * */
      queryHeaderInfo() {
        cSideDriverAccount.detailHeaderInfo({ userId: Number(this.id) }).then(res => {
          this.accountInfo = res || {};
        });
      },
      /**
       * 查询退款详细信息
       */
      getRechargeRefundBox() {
        cSideDriverAccount.getRechargeRefundBox({ id: this.refundId }).then(res => {
          this.refundInfo = res || {};
        });
      },
      /** 根据条件查询数据 */
      searchTableList() {
        const flowListFun = {
          ...this.searchParams,
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };
        cSideDriverAccount.refundFlowList(flowListFun).then(response => {
          this.tableData = response?.records || [];
          this.pageInfo.total = response?.total || 0;
        });
      },

      /**
       * @desc 点击页面左上角按钮 callback
       * */
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(form) {
        this.pageInfo.pageIndex = 1;

        Object.assign(this.searchParams, form);

        if (form.flowTime.length > 0) {
          [this.searchParams.flowTimeStart, this.searchParams.flowTimeEnd] = form.flowTime;
        }

        this.searchTableList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        // Object.assign(this.searchParams, form);
        this.searchParams = { ...this.searchParams, ...form, userId: this.id };

        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);

        this.searchParams.flowTime = [startDate, endDate];
        this.searchParams.flowTimeStart = startDate;
        this.searchParams.flowTimeEnd = endDate;
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
    },
  };
</script>

<style scoped lang="scss">
  .card-info-area {
    box-sizing: border-box;
    .card-info {
      display: flex;
      box-sizing: border-box;
      flex-wrap: nowrap;
      flex-grow: 1;
      width: 892px;
      height: 125px;
      //line-height: 125px;
      background: #ffffff;
      box-shadow: 1px 1px 4px 1px rgba(94, 94, 94, 0.09);
      align-content: center;
      align-items: center;
    }
    .common-icon {
      display: inline-flex;
      box-sizing: border-box;
      width: 70px;
      height: 70px;
      margin-left: 30px;
      background: rgba(77, 140, 253, 0.1);
      border-radius: 14px;
      line-height: 70px;
      align-content: center;
      text-align: center;
      align-items: center;
      justify-content: center;
      .big-icon {
        width: 32px;
        height: 32px;
        display: inline-block;
        background-image: url('~@/assets/images/financial/customDriver/purse@2x.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
      .big-icon.account-icon {
        width: 32px;
        height: 32px;
        display: inline-block;
        background-image: url('~@/assets/images/financial/customDriver/account@2x.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
    .common-text {
      display: inline-flex;
      flex-direction: column;
      margin-left: 30px;
      .account-name {
        //width: 108px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 25px;
      }
      .purse-text {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
      }
      .purse-balance {
        //width: 261px;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
        .purse-unit {
          width: 19px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
        .recharge {
          margin-left: 20px;
          font-size: 14px;
          color: #2678ff;
          cursor: pointer;
        }
      }
    }
    .common-label-key {
      display: inline-block;
      width: 60px;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9b9b9b;
      line-height: 17px;
    }
    .common-label-val {
      display: inline-block;
      //width: 24px;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 17px;
      margin-left: 8px;
    }
    .white-stone {
      width: 16px;
      height: 125px;
    }
  }

  .refund-container {
    .tip {
      background-color: #fef4f3;
      border-radius: 10px;
      border: 1px solid #ffd4d4;
      color: red;
      padding: 20px;
    }
    .amount {
      display: flex;
      margin-bottom: 20px;
      .item-a {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        align-items: center;
        .top {
          margin-bottom: 8px;
        }
        .bottom {
        }
      }
      .item-a-red {
        color: red;
      }
    }
    .tip-coupon {
      color: red;
      margin-bottom: 10px;
    }
  }
</style>
